<template>
    <div>
        <div class="text-center">
            <h3 class="text-uppercase font-weight-bold mb-0" v-if="program.graduate == 0">
                {{$t('transcript.provisionalTranscript')}}
            </h3>
            <p><small class="font-weight-bold">{{$t('transcript.validSeal')}}</small></p>
            <p class="mb-0"><strong>{{program.code}}</strong></p>
            <p class="mb-0">{{type}}</p>
            <p class="mb-0">{{$t('transcript.major')}} {{major}}</p>
            <p class="mb-0 font-weight-bold">
                <small class="font-weight-normal">{{$t('transcript.academicYear')}}<br></small>
                {{ academic_year }}</p>
        </div>

        <div class="my-3">
            <table id="student-detials-table">
                <tr>
                    <td>{{$t('transcript.studentName')}}</td>
                    <th>{{student.name}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.studentNumber')}}</td>
                    <th>{{student.student_number}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.birthDate')}}</td>
                    <th>{{student.birth_date}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.birthPlace')}}</td>
                    <th>{{student.birth_place}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.reportDate')}}</td>
                    <th>{{report_date}}</th>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['student', 'program', 'report_date', 'academic_year', 'is_mabr'],
        data() {
            return {
                    type:'Master of Applied Business Research',
                    major:'Applied Business Research'
            }
        }
    }
  

</script>
